export const Translations = {
  policySearch: {
    title: {
      _: 'Compare & Save with Lowest Prices for car insurance in Singapore',
      'en-hk': 'Compare Best Car Insurance in Hong Kong',
      'zh-hk': '比較香港最佳汽車保險',
    },
    titleMobile: {
      _: 'Compare the best car insurance in Singapore',
      'en-hk': 'Compare Best Car Insurance in Hong Kong',
      'zh-hk': '比較香港最佳汽車保險',
    },
    subtitle: {
      _: "Simply enter your car details below to unlock the best prices and rewards for all types of car insurance coverage policies with SingSaver’s exclusive discounts. If you find a better deal elsewhere, show us and we'll match it.",
      'en-hk':
        'Get instant quote by providing your vehicle and personal details',
      'zh-hk': '提供您的車輛和個人資料即可立即獲取報價',
    },
    subtitleMobile: {
      _: 'Enter your car details below to unlock the best prices & exclusive rewards.',
      'en-hk':
        'Get instant quote by providing your vehicle and personal details',
      'zh-hk': '提供您的車輛和個人資料即可立即獲取報價',
    },
    searchButton: {
      _: 'Search',
      'zh-hk': '搜尋',
    },
    select: {
      searchField: {
        _: 'Type to start searching',
        'zh-hk': '請輸入以開始搜尋',
      },
    },
  },
  sidebars: {
    editQuoteSidebar: {
      title: {
        _: 'Edit quote details',
        'zh-hk': '編輯報價詳情',
      },
      subtitle: {
        _: 'Please enter your personal details to get the best deal.',
        'zh-hk': '請輸入您的個人資料以獲取最佳優惠。',
      },
      carDetailsSubtitle: {
        _: 'Please enter your personal details to get the best deal.',
        'zh-hk': '請輸入您的車輛詳細資料。',
        'en-ph':
          'Please enter the relevant vehicle and personal details to get the best deal.',
      },
      updateButton: {
        _: 'Update Quote',
        'zh-hk': '更新報價',
      },
      form: {
        gender: {
          label: {
            _: 'Gender',
            'zh-hk': '性別',
          },
          values: {
            _: [
              {
                label: 'Male',
                value: 'M',
              },
              {
                label: 'Female',
                value: 'F',
              },
            ],
            'zh-hk': [
              {
                label: '男',
                value: 'M',
              },
              {
                label: '女',
                value: 'F',
              },
            ],
          },
        },
        maritalStatus: {
          label: {
            _: 'Marital Status',
            'zh-hk': '婚姻狀況',
          },
          values: {
            _: [
              {
                label: 'Single',
                value: 'S',
              },
              {
                label: 'Married',
                value: 'M',
              },
            ],
            'zh-hk': [
              {
                label: '單身',
                value: 'S',
              },
              {
                label: '已婚',
                value: 'M',
              },
            ],
          },
        },
        occupationType: {
          label: {
            _: 'Occupation Type',
            'zh-hk': '職業類型',
          },
          values: {
            _: [
              {
                label: 'Indoor',
                value: 'indoor',
              },
              {
                label: 'Outdoor',
                value: 'outdoor',
              },
            ],
            'zh-hk': [
              {
                label: '室內',
                value: 'indoor',
              },
              {
                label: '室外',
                value: 'outdoor',
              },
            ],
          },
        },
        offPeakVehicle: {
          label: {
            _: 'Off-peak Vehicle',
            'zh-hk': '非尖峰時段車輛',
          },
          values: {
            _: [
              {
                label: 'Yes',
                value: 'Y',
              },
              {
                label: 'No',
                value: 'N',
              },
            ],
            'zh-hk': [
              {
                label: '是',
                value: 'Y',
              },
              {
                label: '否',
                value: 'N',
              },
            ],
          },
        },
        age: {
          label: {
            _: 'Age',
            'zh-hk': '年齡',
          },
        },
        drivingExperience: {
          label: {
            _: 'Driving Experience',
            'zh-hk': '駕駛經驗',
          },
          values: {
            _: [
              {
                label: '0 years',
                value: '0',
              },
              {
                label: '1 year',
                value: '1',
              },
              {
                label: '2 years',
                value: '2',
              },
              {
                label: '3 Years and Above',
                value: '3',
              },
            ],
            'zh-hk': [
              {
                label: '0 年',
                value: '0',
              },
              {
                label: '1 年',
                value: '1',
              },
              {
                label: '2 年',
                value: '2',
              },
              {
                label: '3 年及以上',
                value: '3',
              },
            ],
          },
          bolttechValues: {
            _: [
              {
                label: '0 years',
                value: '0',
              },
              {
                label: '1 year',
                value: '1',
              },
              {
                label: '2 years',
                value: '2',
              },
              {
                label: '3 years',
                value: '3',
              },
              {
                label: '4 years',
                value: '4',
              },
              {
                label: '5 years and above',
                value: '5',
              },
            ],
            'zh-hk': [
              {
                label: '0 年',
                value: '0',
              },
              {
                label: '1 年',
                value: '1',
              },
              {
                label: '2 年',
                value: '2',
              },
              {
                label: '3 年',
                value: '3',
              },
              {
                label: '4 年',
                value: '4',
              },
              {
                label: '5 年及以上',
                value: '5',
              },
            ],
          },
        },
        ncd: {
          _: 'NCD',
          'zh-hk': '無索償折扣',
        },
        offenceFree: {
          label: {
            _: 'Do you have any demerit points?',
            'zh-hk': '您是否有資格獲得無違規折扣？',
          },
          values: {
            _: [
              {
                label: 'No',
                value: 'Y',
              },
              {
                label: 'Yes',
                value: 'N',
              },
            ],
            'zh-hk': [
              {
                label: '是',
                value: 'Y',
              },
              {
                label: '否',
                value: 'N',
              },
            ],
          },
          helpText: {
            _: 'Find out if you have a Certificate of Merit (COM).',
            'zh-hk': '查看您是否有榮譽證書（COM）。',
          },
        },
        noc: {
          label: {
            _: 'Number of claims in last 3 years',
            'zh-hk': '過去3年內的理賠次數',
          },
          values: {
            _: [
              {
                label: '0',
                value: '0',
              },
              {
                label: '1',
                value: '1',
              },
              {
                label: '2',
                value: '2',
              },
            ],
            'zh-hk': [
              {
                label: '0',
                value: '0',
              },
              {
                label: '1',
                value: '1',
              },
              {
                label: '2',
                value: '2',
              },
            ],
          },
          bolttechValues: {
            _: [
              {
                label: '0',
                value: '0',
              },
              {
                label: '1',
                value: '1',
              },
              {
                label: '2',
                value: '2',
              },
              {
                label: '3',
                value: '3',
              },
            ],
            'zh-hk': [
              {
                label: '0',
                value: '0',
              },
              {
                label: '1',
                value: '1',
              },
              {
                label: '2',
                value: '2',
              },
              {
                label: '3',
                value: '3',
              },
            ],
          },
        },
      },
      brand: {
        _: 'Vehicle make',
        'zh-hk': '汽車品牌',
      },
      model: {
        _: 'Vehicle model',
        'zh-hk': '車型',
      },
      year: {
        _: 'Year of manufacture',
        'zh-hk': '製造年份',
      },
      variant: {
        _: 'Variant',
        'en-ph': 'Variant',
      },
    },
    providersSidebar: {
      title: {
        _: 'Select insurance providers',
        'zh-hk': '選擇保險提供商',
      },
      reset: {
        _: 'Reset Filters',
        'zh-hk': '重設篩選條件',
      },
      submit: {
        _: 'Show plans',
        'zh-hk': '顯示計劃',
      },
    },
  },
  quote: {
    partOne: {
      _: 'The quote is for',
      'en-hk': 'The quote is based on a',
      'zh-hk': '以',
    },
    partTwo: {
      _: 'years old with',
      'en-hk': '',
      'zh-hk': '年',
      'en-ph': 'email:',
    },
    partThree: {
      _: 'years driving experience',
      'en-hk': '-year-old owner with',
      'zh-hk': '車主',
      'en-ph': 'phone:',
    },
    partFour: {
      _: 'NCD and',
      'en-hk': 'years driving experience, and NCD of',
      'zh-hk': '年以上駕駛經驗及無索償折扣',
    },
    partFive: {
      _: 'number of claims.',
      'en-hk': '',
      'zh-hk': '%計算。',
      'en-ph': 'number of claims,',
    },
    partSix: {
      _: 'injury and damage coverage and',
      'en-ph': 'injury and damage coverage and',
    },
    partSeven: {
      _: 'personal accident.',
      'en-ph': 'personal accident.',
    },
    editButton: {
      _: 'Edit details',
      'zh-hk': '編輯詳情',
    },
  },
  carInsurance: {
    title: 'Car insurance can be pricey, but it doesn’t have to be',
    subtitle: 'Drive worry-free without breaking the bank',
    content:
      "<p class='mb-1'>Car insurance can be expensive, making it hard to get affordable coverage that meets your needs.</p><p class='mb-1'>When you compare quotes on SingSaver, cheaper coverage that’s right for you is within easy reach.</p><p class='mb-1'>So you can drive with peace of mind within your budget.</p>",
  },
  qualityCoverage: {
    title: {
      _: 'Same quality coverage, only cheaper with better value',
      'en-hk': 'Types of Car Insurance',
      'zh-hk': '汽車保險種類',
    },
    subtitle: {
      _: 'Switch to buy car insurance via SingSaver and save',
      'en-hk': 'Choose a type that suits your budget and needs',
      'zh-hk': '因應需要及預算，選擇合適汽車保險',
    },
    content: [
      {
        title: {
          _: 'Customised quotes<br/>at a glance',
          'en-hk': 'Third Party Liability Insurance',
          'zh-hk': '第三者保險',
        },
        icon: '/static-content/Image.png',
        tag: {
          _: 'Basic Cover',
          'zh-hk': '基本保障',
        },
        content: {
          _: 'Compare multiple quotes that match your unique needs at one go. Get covered fast without searching across providers.',
          'en-hk':
            'Coverage for accidents which cause injury or death to a third party, plus damage to others’ property. Damage to your car is not covered.',
          'zh-hk':
            '如第三方不幸因意外而受傷或死亡，可得到賠償。三保同時保障第三方財產損失。然而，三保不會賠償汽車損毁的支出。',
        },
      },
      {
        title: {
          _: 'Same quality coverage<br/>at the lowest prices',
          'en-hk': 'Comprehensive car insurance',
          'zh-hk': '全面保障',
        },
        icon: '/static-content/Image-1.png',
        tag: {
          _: 'Comprehensive Cover',
          'zh-hk': '綜合汽車保險',
        },
        content: {
          _: 'Enjoy the same level of coverage from trusted brands, at the lowest prices in Singapore.',
          'en-hk':
            'Coverage for repair expenses for car damage, personal accident, and medical expenses, plus third-party insurance and additional coverages.',
          'zh-hk':
            '包括第三者保險及額外保障，如汽車損毀之維修支出、個人意外及醫療支出。',
        },
      },
      {
        title: {
          _: 'The most value for<br/>your money',
          'en-hk': 'Advanced Coverage',
          'zh-hk': '升級保障',
        },
        icon: '/static-content/Image-2.png',
        tag: {
          _: 'Advanced Coverage',
          'zh-hk': '升級保障',
        },
        content: {
          _: 'Get the right balance of coverage and price. Save even more with the best discounts and petrol vouchers.',
          'en-hk':
            'Some policies provide additional services, such as 24-hour emergency roadside assistance and free towing services, car parts coverage, temporary car replacement, etc.',
          'zh-hk':
            '部分汽車保險更提供額外服務，包括免費拖車服務、緊急道路救援、汽車零件保障、臨時代用車等。',
        },
      },
    ],
  },
  leadForm: {
    title: {
      _: 'Found what you were looking for?',
      'zh-hk': ' 找到您要的內容了嗎？',
    },
    subtitle: {
      _: 'Please leave us your contact details and we will get back to you as soon as possible.',
      'zh-hk': '請留下您的聯絡資料，我們將儘快與您聯繫。',
    },
    nameInput: {
      _: 'Enter your full name',
      'zh-hk': '輸入您的全名',
    },
    firstNameInput: {
      _: 'Enter your first name',
      'zh-hk': '輸入您的全名',
    },
    lastNameInput: {
      _: 'Enter your last name',
      'zh-hk': '輸入您的全名',
    },
    emailInput: {
      _: 'Enter your email',
      'zh-hk': '輸入您的電子郵件',
    },
    phoneInput: {
      _: 'Enter your phone number',
      'zh-hk': '輸入您的電話號碼',
    },
    marketing: {
      _: 'I consent to receive direct marketing material which includes newsletters, promotional materials and event information about the products and services of SingSaver and/or its affiliates by email, phone and/or other electronic means',
      'en-hk':
        'I consent to receive direct marketing material which includes newsletters, promotional materials and event information about the products and services of MoneyHero and/or its affiliates by email, phone and/or other electronic means',
      'zh-hk':
        '我同意接收直接營銷資料，包括有關 MoneyHero 及/或其附屬公司產品和服務的電子郵件、電話及/或其他電子方式的新聞通訊、促銷材料和活動資訊。',
    },
    mainButton: {
      _: 'Contact me',
      'zh-hk': '聯繫我',
    },
    or: {
      _: 'or',
      'zh-hk': '或',
    },
    WA: {
      _: 'WhatsApp us now',
      'zh-hk': '立即 WhatsApp 我們',
    },
    phoneNow: {
      _: 'Call us now',
      'zh-hk': '立即致電我們',
    },
    emailNow: {
      _: 'Email us now',
      'zh-hk': '立即發送電子郵件給我們',
    },
    timing: {
      _: '*Please note that agents are available from 9 a.m. to 6 p.m. weekdays SGT.',
      'zh-hk':
        '*請注意，客服代表在香港時間週一至週五上午9點至下午6點提供服務。',
    },
    terms: [
      {
        _: "By continuing, you agree to SingSaver's",
        'en-ph': "By continuing, you agree to Moneymax's",
        'zh-hk': '繼續即表示您同意 MoneyHero 的',
      },
      {
        _: 'Terms & Conditions',
        'zh-hk': '條款和條件',
      },
      {
        _: 'and',
        'zh-hk': '及',
      },
      {
        _: 'Privacy Policy',
        'zh-hk': '隱私政策',
      },
    ],
    confirmationModal: {
      title: {
        _: 'Thank you for your interest in SingSaver, we will get back to you as soon as possible.',
        'en-hk':
          'Thank you for your interest in MoneyHero, we will get back to you as soon as possible.',
        'zh-hk': '感謝您對 MoneyHero 的關注，我們將盡快與您聯繫。',
      },
      subtitle: {
        _: 'If you need urgent assistance feel free to drop us a message on WhatsApp.',
        'zh-hk': '如果您需要緊急協助，請隨時通過 WhatsApp 給我們發訊息。',
      },
    },
    errorModal: {
      title: {
        _: 'We faced an error while submitting your data',
        'zh-hk': '我們在提交您的資料時遇到錯誤',
      },
      subtitle: {
        _: 'Something went wrong while submitting your information. Please try filling out the form again.',
        'zh-hk': '在提交您的資訊時出錯了。請再次嘗試填寫表格。',
      },
      tryAgain: {
        _: 'Try again',
        'zh-hk': '再試一次',
      },
    },
  },
  quoteDetailsForm: {
    confirmationModal: {
      title: {
        _: 'Thank you for your interest in SingSaver, we will get back to you as soon as possible.',
        'en-ph':
          'Thank you for your interest in MoneyMax, we will get back to you as soon as possible.',
      },
    },
    errorModal: {
      title: {
        _: 'We faced an error while submitting your data',
      },
      subtitle: {
        _: 'Something went wrong while submitting your information. Please try filling out the form again.',
      },
      tryAgain: {
        _: 'Try again',
      },
    },
  },
  stepper: {
    title: {
      _: 'Getting a car insurance quote via SingSaver is easy',
      'en-hk': 'Getting a car insurance quote via MoneyHero is easy',
      'zh-hk': '透過 MoneyHero 獲取汽車保險報價很簡單',
    },
    subtitle: {
      _: 'Fuss-free comparison and purchase',
      'zh-hk': '輕鬆比較及購買',
    },
    steps: [
      {
        title: {
          _: 'Provide your car and driving details',
          'zh-hk': '提供您的車輛和駕駛資料',
        },
        icon: 'edit_note',
      },
      {
        title: {
          _: 'Compare quotes from trusted brands',
          'zh-hk': '比較報價來自可信品牌',
        },
        icon: 'policy',
      },
      {
        title: {
          _: 'Buy the right plan for your needs',
          'zh-hk': '購買適合的計劃以滿足您的需求',
        },
        icon: 'verified',
      },
      {
        title: {
          _: 'Enjoy your rewards and drive worry-free',
          'zh-hk': '享受您的獎勳安心駕駛',
        },
        icon: 'card_giftcard',
      },
    ],
  },
  emptyList: {
    title: {
      _: 'No results found',
      'zh-hk': '未找到結果',
    },
    subtitle: {
      _: 'Please try adjusting your search or filter to find what you’re looking for.',
      'zh-hk': '請嘗試調整您的搜尋或篩選條件以找到您要的內容。',
    },
    button: {
      _: 'Reset filters',
      'zh-hk': '重置篩選條件',
    },
  },
  contactUsSnackbar: {
    title: {
      _: ' Need help to decide? Talk to our licensed insurance brokers.',
      'en-hk': ' Need help to decide? Talk to our licensed insurance brokers.',
      'zh-hk': '需要幫助決定嗎？與我們的持牌保險經紀人聯繫。',
    },
    prefixIcon: 'email',
    postfixIcon: 'close',
    button: {
      _: 'Contact Us',
      'zh-hk': '聯繫我們',
    },
  },
  results: {
    title: {
      _: 'Results',
      'zh-hk': '結果',
    },
  },
  sort: {
    sortBy: {
      _: 'Sort by',
      'zh-hk': '排序方式',
    },
    price: {
      _: 'Price',
      'zh-hk': '價格',
      'en-ph': 'Low to High Price',
    },
    recommended: {
      _: 'Recommended',
      'zh-hk': '推薦',
      description: {
        _: 'A perfect balance of price and coverage',
        'zh-hk': '以價格和保障完美平衡',
      },
    },
    highestDiscount: {
      _: 'Highest discount',
      'zh-hk': '最高折扣',
    },
    deductible: {
      _: 'Deductible',
      'en-ph': 'Low to High Deductible',
    },
  },
  faq: {
    title: 'How much does car insurance cost?',
    subtitle: 'And other frequently asked questions',
    questions: [
      {
        question: 'How much does car insurance cost?',
        type: 'plain_text',
        answer:
          'On average, annual car insurance premiums in Singapore range from S$700 to S$1,000. This reflects typical market rates, serving as a good baseline for yearly budgeting. To get an exact car insurance quote, compare car insurance policies here on SingSaver.',
      },
      {
        question:
          'What must you look out for when comparing car insurance plans?',
        hint: "Here's a number of things to keep an eye on:",
        type: 'topics',
        answer: [
          {
            title: 'Coverage options',
            content:
              'Learn about the different coverages the policy offers, like liability, collision, comprehensive, uninsured/underinsured motorist, and personal injury protection. Pick the coverage that fits your needs and assess your risk tolerance.',
          },
          {
            title: 'Deductibles',
            content:
              'Evaluate the deductibles for each type of coverage. A higher deductible typically means lower premiums but requires you to pay more out of pocket in the event of a claim.',
          },
          {
            title: 'Policy limits',
            content:
              "Check the policy limits to ensure they provide adequate coverage for your vehicle and assets. Think about your car's value, your financial status, and the possible liabilities if an accident happens. It's all about protecting what matters to you.",
          },
          {
            title: 'Policy exclusions and limitations',
            content:
              'Review the policy to learn about exclusions or limitations affecting coverage, like restrictions on driving other vehicles or specific damage types.',
          },
          {
            title: 'Discounts',
            content:
              'Look out for available discounts for factors such as safe driving, multiple policies, anti-theft devices, or bundling insurance with other products from the same provider. Using these discounts can reduce your premiums.',
          },
          {
            title: 'Customer reviews and ratings',
            content:
              'Dive into customer reviews and ratings for the insurance company. Positive reviews are a good sign of a trustworthy insurer who values great customer service.',
          },
          {
            title: 'Claims process',
            content:
              'Get to know how the insurer handles claims, like how to submit one, how long it might take to get sorted, and what kind of paperwork or proof you might need.',
          },
          {
            title: 'Premiums costs',
            content:
              "Look at premiums from various insurers and think about what coverage and benefits you get. The least expensive policy might not be the best deal if it's missing important coverage or if the customer service is poor.",
          },
          {
            title: 'Additional benefits',
            content:
              'The policy might offer extra benefits or optional coverage like roadside assistance, rental car reimbursement, or accident forgiveness. Consider if these additional features are worth the extra cost.',
          },
        ],
      },
      {
        question: 'How do you purchase a car insurance plan in Singapore?',
        type: 'plain_text',
        answer:
          'You can either buy a car insurance policy directly from an insurer, an insurance broker or through an online comparison platform like SingSaver, depending on your personal preference. \n If you like auto-renewals, buying directly from your current insurer or agent makes that easy. It might prevent you from comparing better deals and coverage with other insurers though.',
      },
      {
        question: 'How much car insurance is enough?',
        type: 'plain_text',
        answer:
          'The right amount of car insurance balances compulsory motor insurance requirements, protection, risk management, and financial stability. Customise your coverage based on these factors to ensure adequate protection and peace of mind for you and your loved ones.',
      },
      {
        question: 'How can I get cheaper car insurance?',
        type: 'plain_text',
        answer:
          'A car insurance comparison tool like ours helps you find, compare, and pick the best plan for you, with the best price and rewards not available elsewhere. We also offer customer support to assist with your paperwork, especially when you switch providers.',
      },
      {
        question: 'What car insurance is best for new drivers?',
        type: 'plain_text',
        answer:
          "For new drivers, it's wise to choose a comprehensive plan that fits your budget and covers all potential damages in an accident. Premiums and excess are typically higher for new or young drivers, as there are also without the benefits of NCD savings.",
      },
      {
        question: 'How are premiums calculated for electric vehicles?',
        type: 'plain_text',
        answer:
          "In Singapore, insurance costs for electric vehicles (EVs) depend on the vehicle's value, repair costs including battery, the driver's risk profile, safety features, usage, and government incentives. While EVs usually cost more initially and require specialised repairs (especially for batteries, leading to higher premiums), advanced safety features and incentives to encourage EV adoption can help reduce costs.",
      },
      {
        question: 'What is NCD?',
        hint: 'The No Claim Discount (NCD) rewards safe driving habits by reducing the premium on future policy renewals, encouraging cautious driving. The table below showcases how most insurers in the industry for Private Car policies calculate NCD.',
        type: 'table',
        answer: {
          columnHeaders: ['Accident-free years', 'NCD percentage awarded'],
          values: [
            {
              'Accident-free years': 'One Year',
              'NCD percentage awarded': '10%',
            },
            {
              'Accident-free years': 'Two Consecutive Years',
              'NCD percentage awarded': '20%',
            },
            {
              'Accident-free years': 'Three Consecutive Years',
              'NCD percentage awarded': '30%',
            },
            {
              'Accident-free years': 'Four Consecutive Years',
              'NCD percentage awarded': '40%',
            },
            {
              'Accident-free years': 'Five or More Consecutive Years',
              'NCD percentage awarded': '50%',
            },
          ],
        },
        footer: {
          content: 'Keen to know more about how NCDs work? Read this article: ',
          link: {
            text: 'Everything You Need to Know About No-Claims Discount (NCD).',
            href: 'https://www.singsaver.com.sg/blog/no-claims-discount',
          },
        },
      },
      {
        question: 'How do I file a car insurance claim?',
        hint: 'Filing a car insurance claim typically involves a few steps:',
        type: 'enumeration',
        enumType: 'single',
        answer: [
          {
            text: 'If safe, keep your car stationary after the accident',
          },
          {
            text: "Contact your insurer's assistance hotline instantly",
          },
          {
            text: 'Take detailed photos of the accident scene',
          },
          {
            text: 'Exchange contact information with the other driver involved',
          },
          {
            text: 'Get your car repaired at an approved workshop',
          },
        ],
      },
      {
        question: 'How do I renew my car insurance?',
        hint: 'Renewing your car insurance in Singapore is a simple process. Here are the steps you need to take:',
        type: 'enumeration',
        enumType: 'single',
        answer: [
          {
            text: "Gather the documents required by your insurance policy provider like your vehicle registration details, driver's licence, and other relevant documents.",
          },
          {
            text: 'Contact your insurance provider to obtain a car insurance renewal quotation based on your current policy and payment history.',
          },
          {
            text: 'Compare car insurance renewal quotations from multiple providers and select the best one for you.',
          },
          {
            text: 'Make the payment for your car insurance renewal, either by cash, cheque, or credit card.',
          },
          {
            text: 'Once you make your payment, your car insurer will process your car insurance renewal.',
          },
          {
            text: 'Your car insurance policy documents will reach you via email or post.',
          },
        ],
        footer: {
          content:
            'Want to know more about renewing your car insurance plan? Read the article here: ',
          link: {
            text: '5 Things You Need to Check When Buying or Renewing Your Car Insurance Policy',
            href: 'https://www.singsaver.com.sg/blog/things-to-check-once-your-car-insurance-starts-or-is-renewed',
          },
        },
      },
      {
        question: 'How do I report a car accident?',
        hint: "If you're involved in a car accident, it's crucial to prioritise safety and follow the necessary steps to ensure a smooth process afterwards. Here's a checklist to guide you:",
        type: 'enumeration',
        enumType: 'single',
        answer: [
          {
            text: "Check everyone's well-being and move vehicles to a safe location.",
          },
          {
            text: 'If there are injuries, immediately contact emergency services.',
          },
          {
            text: 'Exchange information with the other parties involved.',
          },
          {
            text: 'Collect details and contact information from witnesses.',
          },
          {
            text: 'Notify the police, even for minor accidents.',
          },
          {
            text: 'Document the scene with photos, capturing all relevant details.',
          },
          {
            text: 'Promptly contact your insurance company and provide all necessary details.',
          },
          {
            text: 'Seek medical attention for any injuries, even minor ones.',
          },
          {
            text: 'Follow up with authorities, your insurance, and healthcare providers for proper documentation and resolution.',
          },
          {
            text: 'Submit your insurance claim receipts and documents if required to expedite your insurance claims process.',
          },
        ],
      },
      {
        question: 'How do you handle a hit-and-run accident?',
        hint: "Handling a hit and run requires quick and smart actions. Here's what to do:",
        type: 'enumeration',
        enumType: 'single',
        answer: [
          {
            text: "Ensure your and passengers' safety by moving to a safe location.",
          },
          {
            text: "Note the fleeing vehicle's details (make, model, colour, licence plate, etc.) if possible.",
          },
          {
            text: 'Call emergency services immediately to report the incident with all details.',
          },
          {
            text: 'Get contact information from any witnesses.',
          },
          {
            text: "Document the scene with photos of your vehicle's damage and any other evidence.",
          },
          {
            text: 'Inform your insurance company, providing all gathered information.',
          },
          {
            text: 'Avoid confronting or following the fleeing driver to ensure your safety.',
          },
          {
            text: 'Cooperate with law enforcement, offering any evidence or information you have.',
          },
        ],
      },
      {
        question: 'What happens when I cancel my car insurance?',
        type: 'plain_text',
        answer:
          "Cancelling your car insurance depends on your insurer's terms. Usually, cancelling before renewal means you could get back 70% of the unused premium, with the insurer keeping 30%. It's generally better to switch insurers at renewal to avoid penalties. Also, note that insurers can cancel your policy, potentially without a refund, for reasons like suspected fraud or illegal modifications.",
      },
    ],
  },
  tipsAndArticles: {
    title: {
      _: 'Get the latest car insurance tips',
      'zh-hk': '獲取最新的汽車保險提示',
    },
    subtitle: {
      _: 'Choose the right coverage and save money',
      'zh-hk': '選擇合適的保障，節省開支',
    },
    seeAllButton: {
      text: {
        _: 'See All Tips',
        'zh-hk': '查看所有提示',
        'en-ph': 'Read More',
      },
      link: {
        _: 'https://www.singsaver.com.sg/blog/category/protect-yourself/car-insurance',
        'en-hk': 'https://www.moneyhero.com.hk/blog/en',
        'zh-hk':
          'https://www.moneyhero.com.hk/blog/tag/%E6%B1%BD%E8%BB%8A%E4%BF%9D%E9%9A%AA',
        'en-ph': 'https://www.moneymax.ph/articles/insurance/car-insurance',
      },
    },
    content: {
      _: [
        {
          title: 'Cheapest Car Insurance in Singapore: 7 Plans to Purchase',
          icon: '/static-content/first_tip.png',
          badge: 'Car insurance',
          link: 'https://www.singsaver.com.sg/blog/cheapest-car-insurance-singapore',
        },
        {
          title:
            '5 Things You Need to Check When Buying or Renewing Your Car Insurance Policy',
          icon: '/static-content/second_tip.png',
          badge: 'Car insurance',
          link: 'https://www.singsaver.com.sg/blog/things-to-check-once-your-car-insurance-starts-or-is-renewed',
        },
        {
          title:
            'How to Claim Car Insurance: A Complete Guide to Making a Claim',
          icon: '/static-content/third_tip.png',
          badge: 'Car insurance',
          link: 'https://www.singsaver.com.sg/blog/how-to-claim-car-insurance-a-complete-guide-to-making-a-claim',
        },
      ],
      'en-hk': [
        {
          title:
            'Third Party Car Insurance In HK | What Is Third Party Liability Insurance?',
          icon: '/static-content/first_tip_mh_en.jpg',
          badge: 'Car insurance',
          link: 'https://www.moneyhero.com.hk/blog/en/third-party-car-insurance-liability',
        },
        {
          title:
            'No Claim Discount (NCD/NCB) | How to Calculate NCD and Lower Car Insurance Premium',
          icon: '/static-content/second_tip_mh_en.jpg',
          badge: 'Car insurance',
          link: 'https://www.moneyhero.com.hk/blog/en/no-claim-discount-ncd-ncb',
        },
        {
          title:
            'Car Examination: How much? What are the Documents Required+Points to Note for Licence Renewal',
          icon: '/static-content/third_tip_mh_en.jpg',
          badge: 'Car insurance',
          link: 'https://www.moneyhero.com.hk/blog/en/car-examination',
        },
      ],
      'zh-hk': [
        {
          title:
            '汽車保險入門 | 三保與全保有甚麼分別？墊底費是甚麼？比較6大車保邊間好',
          icon: '/static-content/first_tip_mh_tc.jpg',
          badge: '汽車保險',
          link: 'https://www.moneyhero.com.hk/blog/zh/%e6%b1%bd%e8%bb%8a%e4%bf%9d%e9%9a%aa-%e5%85%a8%e4%bf%9d-%e4%b8%89%e4%bf%9d-%e5%a2%8a%e5%ba%95%e8%b2%bb',
        },
        {
          title: '無索償折扣NCD/NCB計算方法+6大香港NCB車保比較2024',
          icon: '/static-content/second_tip_mh_tc.jpg',
          badge: '汽車保險',
          link: 'https://www.moneyhero.com.hk/blog/zh/%E7%84%A1%E7%B4%A2%E5%84%9F%E6%8A%98%E6%89%A3-ncd-ncb',
        },
        {
          title: '驗車價錢？驗車文件？政府驗車續牌必睇攻略+注意事項',
          icon: '/static-content/third_tip_mh_tc.jpg',
          badge: '汽車保險',
          link: 'https://www.moneyhero.com.hk/blog/zh/%E9%A9%97%E8%BB%8A%E9%A0%85%E7%9B%AE%E6%94%B6%E8%B2%BB-%E6%96%87%E4%BB%B6-%E7%BA%8C%E7%89%8C%E8%B2%B7%E8%BB%8A-%E6%B5%81%E7%A8%8B-%E8%BB%8A%E8%BC%9B%E6%AA%A2%E9%A9%97%E6%94%BB%E7%95%A5',
        },
      ],
    },
  },
  rewardsModal: {
    header: {
      oneReward: {
        _: 'Reward available',
        'zh-hk': '獎賞',
      },
      multipleRewards: {
        _: 'Rewards available',
        'zh-hk': '獎賞',
      },
    },
    footer: {
      button: {
        _: 'Buy',
        'zh-hk': '購買',
      },
    },
  },
  productCard: {
    header: {
      buy: {
        _: 'Buy Now',
        'zh-hk': '購買',
      },
      getQuote: {
        _: 'Check Final Price',
        'zh-hk': '查看最終報價',
      },
      startingAt: {
        _: 'Starting at',
        'zh-hk': '起',
      },
      startingFrom: {
        _: 'Starting from',
        'zh-hk': '起價',
      },
      priceSymbol: {
        _: 'S$',
        'en-hk': 'HK$',
        'zh-hk': 'HK$',
      },
      priceApproximate: {
        _: 'Approx. <u>indicative price</u> after discounts',
        'zh-hk': '參考價格',
      },
      priceApproximateDynamic: {
        _: 'Approx. price after discounts',
        'zh-hk': '參考價格',
      },
      highlight: {
        _: '🎁 Highest PayNow of S$130 reward in Singapore 🎁',
        'zh-hk': '🎁 香港最高汽油券獎賞 🎁',
      },
      extensiveCover: {
        _: 'Extensive cover | Opt for authorised workshops to save 15% and halve your excess',
      },
      uniqueCoverage: {
        _: 'Unique coverage | overseas emergency medical evacuation and repatriation',
      },
      highlightLowestNCD: {
        _: 'Low NCD Penalty | Penalty of only 10% for each claim',
      },
      highlightHighestPersonalAccident: {
        _: '⛑️ Highest personal accident coverage of up to $120,000 ⛑️',
      },
      highlightPayNowUpTo240: {
        _: '🎁 Highest PayNow of up to S$240 reward in Singapore 🎁',
      },
      highlightLowExcess: {
        _: 'Low Excess | Repair excess may be as low as $0',
      },
      fetchingLivePricing: {
        _: 'Fetching live pricing...',
        'zh-hk': '正在獲取即時價格...',
      },
      livePricingTag: {
        _: 'Live-pricing',
        'zh-hk': '即時報價',
      },
    },
    body: {
      included: {
        _: 'Included',
        'zh-hk': '包括',
      },
      notIncluded: {
        _: 'Not Included',
        'zh-hk': '不包括',
      },
      addon: {
        _: 'Available to add on',
        'zh-hk': '可附加',
      },
      tooltip: {
        _: 'Based on a 35 year old married male driving a 2021 Honda Vezel 1.5 with 50% NCD, a clean driving record, 10 years of driving experience with 0 claims in the last 3 years.',
        'en-hk':
          'Based on a 2022 Honda Jazz, а 35-year-old owner with 5 years of driving experience and a NCD of 60%.',
        'zh-hk': '以2022年Honda Jazz、車主35歲、5年駕駛經驗及無索償折扣60%計算',
      },
      tooltipEstimate: {
        _: 'The prices shown are just estimates and can change. For the most accurate pricing, please check the insurance provider’s website.',
        'zh-hk': '報價只供參考，實際保費以保險公司網站為準。',
      },
    },
    footer: {
      rewards: {
        _: 'Rewards',
        'zh-hk': '獎賞',
      },
      policyDocument: {
        _: 'Policy document',
        'zh-hk': '保單文件',
      },
    },
  },
  metadata: {
    singsaver: {
      title: {
        _: 'Buy Car Insurance in Singapore: Get Quote Online',
      },
      description: {
        _: 'Looking to compare the best car insurance for your needs? Find out how much is car insurance in Singapore from the best insurance providers and compare the most affordable one for you at SingSaver. Get a quote online for virtually all car models including electric cars with the most comprehensive coverage suitable for you!',
      },
    },
    moneyhero: {
      title: {
        _: 'Buy Car Insurance in Hong Kong | Get a Quote Online!',
        'zh-hk':
          '汽車保險: 即時網上報價，比較香港私家車全保及第三者保險 | MoneyHero',
      },
      description: {
        _: 'Buy car insurance in Hong Kong online! Compare quotes for comprehensive, third-party, and motor insurance. Enjoy low premiums, flexible coverage options, and quick policy issuance. Get your tailored car insurance quote now!',
        'zh-hk':
          'MoneyHero度身打造最適合你的汽車保險！即時取得網上汽車保險報價，助你一次過比較不同車保，包括私家車全保及第三者保險（三保）',
      },
    },
  },
  exclusiveRewards: {
    header: {
      giftsAvailable: {
        _: "Don't miss out on exclusive rewards...",
        'zh-hk': '不要錯過獨家獎勵...',
      },
      giftsNotAvailable: {
        _: 'You’re almost done!',
        'zh-hk': '您快完成了！',
      },
      back: {
        _: 'Back',
        'zh-hk': '返回',
      },
    },
    body: {
      rewardsInfo: {
        noRewards: {
          _: 'No rewards available for this product',
          'zh-hk': '此產品沒有可用的獎勳',
        },
        multipleRewards: {
          _: 'You’ll get to choose one of these rewards:',
          'zh-hk': '您可以選擇以下其中一項獎勵:',
        },
        title: {
          multipleGiftsAvailable: {
            _: 'Plus, you’ll get:',
            'zh-hk': '此外，您還將獲得:',
          },
          multipleGiftsNotAvailable: {
            _: 'You will get this reward:',
            'zh-hk': '您將獲得以下獎勵:',
          },
        },
        terms: [
          {
            _: '*Campaign',
            'zh-hk': '公司的',
          },
          {
            _: '*T&Cs apply',
            'zh-hk': 'T&Cs 已到位',
          },
        ],
      },
      brandUserInfo: {
        price: {
          originalPrice: {
            _: 'Original premium',
            'zh-hk': '原始保費',
          },
          discountPrice: {
            _: "You'll pay only",
            'zh-hk': '您只需支付',
          },
        },
        attributes: {
          makeName: {
            _: 'Vehicle make',
            'zh-hk': '汽車品牌',
          },
          modelName: {
            _: 'Vehicle model',
            'zh-hk': '車型',
          },
          manufactureYear: {
            _: 'Manufacture year',
            'zh-hk': '製造年份',
          },
          gender: {
            title: {
              _: 'Gender',
              'zh-hk': '性別',
            },
            male: {
              _: 'Male',
              'zh-hk': '男',
            },
            female: {
              _: 'Female',
              'zh-hk': '女',
            },
          },
          maritalStatus: {
            title: {
              _: 'Marital status',
              'zh-hk': '婚姻狀況',
            },
            single: {
              _: 'Single',
              'zh-hk': '單身',
            },
            married: {
              _: 'Married',
              'zh-hk': '已婚',
            },
          },
          age: {
            title: {
              _: 'Age',
              'zh-hk': '年齡',
            },
            years: {
              _: 'y.o.',
              'zh-hk': '歲',
            },
          },
          totalDrivingExperience: {
            title: {
              _: 'Driving experience',
              'zh-hk': '駕駛經驗',
            },
            years: [
              {
                _: '0 years',
                'zh-hk': '0 年',
              },
              {
                _: '1 year',
                'zh-hk': '1 年',
              },
              {
                _: '2 years',
                'zh-hk': '2 年',
              },
              {
                _: '3 years and above',
                'zh-hk': '3 年及以上',
              },
            ],
          },
          ncd: {
            _: 'NCD',
            'zh-hk': '無索償折扣',
          },
          numberOfClaims: {
            _: 'Number of claims in last 3 years',
            'zh-hk': '過去3年內的理賠次數',
          },
        },
      },
    },
    footer: {
      shareEmail: {
        _: 'Share your email address to receive the rewards claim form.',
        'zh-hk': '提供您的電子郵件地址，以接收報獎表格。',
      },
      emailError: {
        _: 'Please enter a valid email address',
        'zh-hk': '請輸入有效的電子郵件地址',
      },
      redirect: {
        _: 'You’ll be redirected to',
        'zh-hk': '您將被重定向到',
      },
      buy: {
        _: 'Continue',
        'zh-hk': '繼續購買',
      },
      subscribe: {
        _: 'I consent to receiving marketing materials from SingSaver Pte Ltd / SingSaver Insurance Brokers Pte Ltd about their products, services, offers & events by email, phone call, IM or text as per their',
        en_hk:
          'I consent to receiving marketing materials from MoneyHero Global Limited / MoneyHero Insurance Brokers Limited about their products, services, offers & events by email, phone call, IM or text as per their',
        'zh-hk':
          ' 我同意通過電子郵件、電話、即時消息或短信接收有關 MoneyHero Global Limited / MoneyHero Insurance Brokers Limited 的產品、服務、優惠和活動的營銷材料，並且同意其',
      },
      privacyPolicy: {
        _: 'Privacy Policy.',
        'zh-hk': '隱私政策。',
      },
      terms: [
        {
          _: 'By entering your email address, you agree to SingSaver’s',
          'zh-hk': '輸入您的電子郵件地址，即表示您同意 MoneyHero 的',
        },
        {
          _: 'T&Cs',
          'zh-hk': '使用條款',
        },
        {
          _: 'and',
          'zh-hk': '和',
        },
        {
          _: 'Privacy Policy.',
          'zh-hk': '隱私權政策。',
        },
      ],
    },
  },
};
